import { CaretDownIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";

import { DOCUMENT_SORT_OPTIONS, type DocumentSort } from "../types/document";

type DocumentsPageHeaderProps = {
  title: string;
  description: string;
  sort: DocumentSort;
  onSortChange: (sort: DocumentSort) => void;
  className?: string;
};

export const DocumentsPageHeader = ({
  title,
  description,
  sort,
  onSortChange,
  className,
}: DocumentsPageHeaderProps) => {
  return (
    <header
      className={cn(
        "flex flex-col gap-4",
        "sm:flex-row sm:items-end sm:justify-between",
        className,
      )}
    >
      <div className="min-w-0">
        <h1 className="text-2xl font-bold tracking-tight text-indigo-950 sm:text-[26px]">
          {title}
        </h1>

        <p className="mt-1 text-[13px] leading-5 text-slate-600 sm:text-sm">{description}</p>
      </div>

      <div className="relative w-full shrink-0 sm:w-auto">
        <label htmlFor="documents-sort" className="sr-only">
          Trier les documents
        </label>

        <select
          id="documents-sort"
          value={sort}
          onChange={(event) => {
            onSortChange(event.target.value as DocumentSort);
          }}
          className={cn(
            "h-11 w-full appearance-none rounded-xl",
            "border border-slate-200 bg-white",
            "pl-4 pr-10 text-[13px] font-semibold",
            "text-indigo-950 shadow-sm",
            "transition-colors hover:border-indigo-300",
            "focus:border-indigo-500 focus:outline-none",
            "focus:ring-2 focus:ring-indigo-200",
            "sm:min-w-36",
          )}
        >
          {DOCUMENT_SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <CaretDownIcon
          aria-hidden
          size={15}
          className={cn(
            "pointer-events-none absolute right-3",
            "top-1/2 -translate-y-1/2 text-indigo-950",
          )}
        />
      </div>
    </header>
  );
};
